import { useCallback, useEffect, useRef, useState } from "react";

const HOVER_DELAY_MS = 1000;
const YT_ID = /youtube(?:-nocookie)?\.com\/embed\/([\w-]{11})/;

const canPreview = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(hover: hover) and (pointer: fine) and (min-width: 1024px)").matches &&
  !document.documentElement.classList.contains("is-tv");

// Muted, looping, control-less YouTube embed URL for a card preview (null when not previewable).
export const previewSrc = (video) => {
  const id = (video.monetized_embed_url || "").match(YT_ID)?.[1];
  if (!id || video.is_live || video.requires_affiliate_redirect) return null;
  const dur = video.duration_sec || 0;
  const start = dur > 600 ? Math.min(Math.round(dur * 0.1), 300) : 0;
  const q = `autoplay=1&mute=1&controls=0&loop=1&playlist=${id}&modestbranding=1&playsinline=1&rel=0&iv_load_policy=3&disablekb=1&fs=0&enablejsapi=1&origin=${encodeURIComponent(window.location.origin)}&start=${start}`;
  return `https://www.youtube.com/embed/${id}?${q}`;
};

export const useHoverPreview = (video) => {
  const [active, setActive] = useState(false);
  const timer = useRef(null);
  const src = previewSrc(video);

  const onEnter = useCallback(() => {
    if (!src || !canPreview()) return;
    timer.current = setTimeout(() => setActive(true), HOVER_DELAY_MS);
  }, [src]);
  const onLeave = useCallback(() => {
    clearTimeout(timer.current);
    setActive(false);
  }, []);
  useEffect(() => () => clearTimeout(timer.current), []);

  return { src, active, onEnter, onLeave };
};
